export default __webpack_public_path__ + "static/media/SAND.177b6957.png";